import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface IProps {
    customerId: string;
    consentData: FormData;
}

export const useUploadConsent = () => useMutation('useUploadConsent', async ({ customerId, consentData }: IProps) => {
  const res = await httpService.post(
    `${BASE_URL}/api/v1/user/${customerId}/terms_and_conditions/consent`,
    consentData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return res.data;
});
